import timezones from '@/timezones.json'

export default {
    methods: {
        timeZoneByName(name, fallback = 'Etc/UTC') {
            return timezones.find(tz => tz.value === name) ||
                timezones.find(tz => tz.value === fallback)
        },
        timezones() {
          return timezones
        }
    }
}
